import { render } from "./UserFormContainer.vue?vue&type=template&id=07e105f4"
import script from "./UserFormContainer.vue?vue&type=script&lang=js"
export * from "./UserFormContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__